import script from "./PartnerList.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerList.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/account.css?vue&type=style&index=0&id=d843d68e&scoped=true&lang=css&external"
import "./PartnerList.vue?vue&type=style&index=1&id=d843d68e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d843d68e"]])

export default __exports__